import { PosologyBlockCommonProps } from '../PosologyDetail.model'

export interface DurationBlockProps extends PosologyBlockCommonProps {}

export const PREDEFINED_MIN_TIME_VALUE = 1
export const PREDEFINED_MAX_TIME_VALUE = 9
